module.exports = __webpack_public_path__ + "static/media/1.beda4513.jpg";